export default __webpack_public_path__ + "static/media/sale-women.4f0c0e60.png";